import { api } from "api";

export const getFile = (
  fileUrl,
  onBegin,
  onSuccess,
  onError,
  persistOnStore
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(fileUrl)
      .then(async (res) => {
        // console.dir(res.);
        let base64data = null;
        let reader = new FileReader();
        reader.readAsDataURL(res.data);
        reader.onloadend = () => {
          base64data = reader.result;

          let payload = {
            id: fileUrl,
            binary: base64data,
            error: null,
            persistOnStore,
            raw: res,
          };

          dispatch({
            type: "GET_FILE_SUCCESS",
            payload: payload,
          });

          onSuccess(payload, res.headers);
        };
      })
      .catch((e) => {
        dispatch({
          type: "GET_FILE_ERROR",
          payload: { error: e },
        });
        onError(e);
      });
  };
};
